import { Modal } from 'components/molecules/Modal'
import type { TermsModalProps } from './types'
import { closeModal, cn } from 'lib/utils'
import { useForms } from 'lib/contexts/FormsContext'

const mainClass = 'terms'

export const TermsModal = ({ title }: TermsModalProps) => {
  const { terms } = useForms()

  return (
    <Modal title={title} onClose={closeModal} className="modal--terms">
      {terms && (
        <div
          className={cn(mainClass)}
          dangerouslySetInnerHTML={{ __html: terms }}
        />
      )}
    </Modal>
  )
}
